import { jsx, jsxs } from "react/jsx-runtime";
import styled, { css } from "styled-components";
import { textStyles } from "./textStyles.js";
import { token } from "./token.js";
import { Flex } from "./Flex.js";
import { TruncatedText } from "./TruncatedText.js";
function Cell({
  thumbnail,
  subtext,
  children,
  variant = "primary",
  textFlow = "wrap",
  iconRight,
  ...props
}) {
  const isTruncated = textFlow === "truncated";
  return /* @__PURE__ */ jsx(StyledCell, {
    $variant: variant,
    $isTruncated: isTruncated,
    ...props,
    children: /* @__PURE__ */ jsxs(Flex, {
      gap: "4",
      alignItems: "center",
      children: [thumbnail && /* @__PURE__ */ jsx(ThumbnailWrapper, {
        children: thumbnail
      }), /* @__PURE__ */ jsxs(Content, {
        $isNoWrap: textFlow === "no-wrap",
        children: [/* @__PURE__ */ jsx("div", {
          children: isTruncated ? /* @__PURE__ */ jsx(TruncatedText, {
            children
          }) : children
        }), subtext ? /* @__PURE__ */ jsx(Subtext, {
          children: isTruncated ? /* @__PURE__ */ jsx(TruncatedText, {
            children: subtext
          }) : subtext
        }) : null]
      }), iconRight ? /* @__PURE__ */ jsx(IconRight, {
        children: iconRight
      }) : null]
    })
  });
}
const StyledCell = styled.td.withConfig({
  displayName: "StyledCell",
  componentId: "sc-1yh36dr-0"
})(["", " ", " padding:", " ", ";word-break:break-word;&[data-checkbox-cell]{width:16px;}&[data-icon-cell]{width:24px;padding-left:0;}tr &:first-child{border-top-left-radius:", ";border-bottom-left-radius:", ";}tr &:last-child{border-top-right-radius:", ";border-bottom-right-radius:", ";}"], (props) => {
  if (props.$variant === "primary") {
    return css(["", " color:var(--table-row-color-override,", ");"], textStyles.uiTextM, token.colorText);
  }
  if (props.$variant === "secondary") {
    return css(["", " color:var(--table-row-color-override,", ");"], textStyles.uiTextS, token.colorTextMuted);
  }
}, (props) => props.$isTruncated && "max-width: 1px;", token.spacing3, token.spacing4, token.radiusLarge, token.radiusLarge, token.radiusLarge, token.radiusLarge);
const ThumbnailWrapper = styled.div.withConfig({
  displayName: "ThumbnailWrapper",
  componentId: "sc-1yh36dr-1"
})(["flex:none;align-self:flex-start;opacity:var(--table-thumbnail-opacity,1);"]);
const Content = styled.div.withConfig({
  displayName: "Content",
  componentId: "sc-1yh36dr-2"
})(["flex:1;min-width:0;white-space:", ";"], (props) => props.$isNoWrap ? "nowrap" : "normal");
const Subtext = styled.div.withConfig({
  displayName: "Subtext",
  componentId: "sc-1yh36dr-3"
})(["", " color:var(--table-row-color-override,inherit);"], textStyles.uiTextS);
const IconRight = styled.div.withConfig({
  displayName: "IconRight",
  componentId: "sc-1yh36dr-4"
})(["flex:none;margin-left:", ";color:", ";"], token.spacing4, token.colorTextMuted);
export {
  Cell
};
//# sourceMappingURL=Cell.js.map
